import { cx } from 'utils/cx'

import type { ChipProps } from './types/types'

import text from 'fukku/styles/texts.module.scss'
import styles from './Chip.module.scss'

export function Chip({
	name,
	handleClick,
	className,
	selected = false,
	disabled = false,
	'data-testid': dataTestId,
}: Readonly<ChipProps>) {
	const onClick = (value: string) => handleClick(value)

	return (
		<button
			type='button'
			className={cx(
				styles.label,
				text.bodyMRegular,
				selected && styles.selected,
				!!className && className
			)}
			disabled={disabled}
			onClick={() => onClick(name)}
			data-testid={dataTestId}
		>
			{name}
		</button>
	)
}
